import { useState } from "react";
import { PasswordInput } from "./PasswordInput";

/** First password or new password. The server keeps the rules (8 characters minimum). */
const PasswordForm = ({ title, intro, submitLabel, onSubmit, testId = "password-form" }) => {
  const [password, setPassword] = useState("");
  const [again, setAgain] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("Au moins 8 caractères.");
      return;
    }
    if (password !== again) {
      setError("Les deux mots de passe ne sont pas identiques.");
      return;
    }
    setBusy(true);
    try {
      const problem = await onSubmit(password);
      if (problem) setError(problem);
    } finally {
      setBusy(false);
    }
  };

  const field =
    "mt-2 w-full rounded-2xl border border-gray-200 px-4 py-3 text-base outline-none focus:border-[#25D366]";
  return (
    <form onSubmit={submit} className="mt-8" data-testid={testId}>
      <h1 className="font-display text-3xl font-bold text-[#122118]">{title}</h1>
      {intro && <p className="mt-2 leading-relaxed text-[#4a5f53]">{intro}</p>}
      <label className="mt-6 block text-xs font-bold uppercase tracking-wider text-[#189346]" htmlFor="pw-new">
        Mot de passe
      </label>
      <PasswordInput
        id="pw-new"
        testId="password-new"
        autoComplete="new-password"
        autoFocus
        value={password}
        onChange={(event) => setPassword(event.target.value)}
        className={field}
      />
      <label className="mt-4 block text-xs font-bold uppercase tracking-wider text-[#189346]" htmlFor="pw-again">
        Encore une fois
      </label>
      <PasswordInput
        id="pw-again"
        testId="password-again"
        autoComplete="new-password"
        value={again}
        onChange={(event) => setAgain(event.target.value)}
        className={field}
      />
      <p className="mt-2 text-xs text-[#829c8d]">8 caractères au minimum.</p>
      {error && (
        <p className="mt-3 text-sm text-[#9b3b3b]" data-testid="password-error">
          {error}
        </p>
      )}
      <button
        type="submit"
        data-testid="password-submit"
        disabled={busy}
        className="mt-5 w-full rounded-full px-6 py-3.5 text-base font-semibold disabled:opacity-50"
        style={{ background: "var(--sp-primary)", color: "var(--sp-text-on-primary)" }}
      >
        {submitLabel}
      </button>
    </form>
  );
};

export default PasswordForm;
